import { object, bool } from "prop-types";

import React from "react";
import JsonView from "react18-json-view";
import "react18-json-view/src/style.css";

function VisualizadorJson({ json, collapsed }) {
  return (
    <JsonView
      src={json === undefined ? {} : json}
      collapsed={collapsed}
      displaySize={true}
      enableClipboard={false}
    />
  );
}

VisualizadorJson.propTypes = {
  json: object,
  collapsed: bool
};

export default VisualizadorJson;
